import React from "react"

import {BREAKDOWN_ALL_VALUES} from "../../../../../gd-modules/tasks-view/core/@const"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view"

export default function FieldTaskStatus_QuickFilterView(props: FieldQuickFilterViewProps) {


    const {value} = props

    let label = ''
    let icon = null

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All statuses'
            break

        default:
            const status = gd.session.statuses.get(value);

            if (status) {
                icon = <div className={Classes("group-icon m-r-10", "ui5-color-box", "gd-scbg-{0}".f(status.color))}/>
                label = status.name
            } else {
                label = value
            }
    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}